export default __webpack_public_path__ + "static/galatasaray-logo-5e6e6d1876d85b8353c3d852c1b3e63b.png";